export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8275.4337b61a.jpg";